import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Loader from '@jumbo/components/common/Loader';
import { Link, useParams } from 'react-router-dom';
import { editOrder } from 'app/redux/slice/orderSlice';
import CardComponent from '@jumbo/components/common/Card';
import { Grid, Typography } from '@mui/material';
import { ASSET_IMAGES } from 'app/utils/constants/paths';
import moment from 'moment';

const OrderInfo = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const storeId = localStorage.getItem('selectedStoreId');
  const [loading, setLoading] = useState(true);
  const [orderData, setOrderData] = useState({});

  useEffect(() => {
    if (storeId && id) {
      dispatch(editOrder({ id, data: { selectedStoreId: storeId } }))
        .unwrap()
        .then((res) => {
          if (res?.status === 200) {
            setOrderData(res?.data?.data?.order);
          }
          setLoading(false);
        });
    }
  }, [storeId, id]);
  function getImageExtension(url) {
    url = url.split('?')[0];
    const extension = url.split('.').pop().toLowerCase();
    const validExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'];
    if (validExtensions.includes(extension)) {
      return extension;
    } else {
      return null;
    }
  }
  const commonImgFun = (imgURL) => {
    if (getImageExtension(imgURL)) {
      return imgURL.replaceAll(process.env.REACT_APP_DROPBOX_START_POINT, process.env.REACT_APP_DROPBOX_START_NEW_POINT);
    } else {
      if (imgURL.includes('drive.google.com')) {
        const params = new URLSearchParams(new URL(imgURL).search);
        const fileId = params.get('id');
        return `https://lh3.googleusercontent.com/d/${fileId}`;
      }
      return false;
    }
  };
  const handleReplace = (stringValue) => {
    let imageUrl = `${ASSET_IMAGES}/no-img.png`;
    if (stringValue) {
      const { image, print_url, print_url_1, Print_url, Image } = stringValue;
      if (image) {
        imageUrl = commonImgFun(image);
      } else if (print_url) {
        imageUrl = commonImgFun(print_url);
      } else if (print_url_1) {
        imageUrl = commonImgFun(print_url_1);
      } else if (Print_url) {
        imageUrl = commonImgFun(Print_url);
      } else if (Image) {
        imageUrl = commonImgFun(Image);
      }
      if (!imageUrl) imageUrl = `${ASSET_IMAGES}/no-img.png`;
    }
    return imageUrl;
  };
  // Helper to resolve a thumbnail URL from metadata, returns false-y if absent
  const getThumbnail = (url) => {
    if (!url) return null;
    const resolved = commonImgFun(url);
    return resolved || null;
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {/* Order-Level Info */}
          <CardComponent title={`Order Info ${orderData?.id}`}>
            <Grid container spacing={2}>
              <Grid item xs={4} sx={{ justifyContent: 'center' }}>
                <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                  {`Order ID : ${orderData?.source_id}`}
                </Typography>
                <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                  {`Order Date : ${moment(orderData?.date_added).format('DD/MM/YYYY')}`}
                </Typography>
                <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                  {`First Name : ${orderData?.customer?.first_name}`}
                </Typography>
                <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                  {`Last Name : ${orderData?.customer?.last_name}`}
                </Typography>
                <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                  {`Status : ${orderData?.orderStatus}`}
                </Typography>
                <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                  {`Tracking Number : ${orderData?.order_shipments?.[0]?.tracking_number ? '' : '-'}`}
                </Typography>
                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                  {orderData?.order_shipments?.length
                    ? orderData.order_shipments.map((s, idx) => (
                        <Link
                          key={idx}
                          to={s.tracking_url}
                          target="_blank"
                          style={{
                            padding: '4px 8px',
                            background: '#e3f2fd',
                            borderRadius: '6px',
                            fontSize: '12px',
                            textDecoration: 'none',
                            color: '#1976d2',
                          }}>
                          {s.tracking_number}
                        </Link>
                      ))
                    : '-'}
                </div>
              </Grid>
              <Grid item xs={4} sx={{ justifyContent: 'center' }}>
                <Typography variant={'h1'} sx={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '20px' }}>
                  Shipping Address
                </Typography>
                <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                  {`${orderData?.shipping?.first_name} ${orderData?.shipping?.last_name}`}
                </Typography>
                <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                  {orderData?.shipping?.company}
                </Typography>
                <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                  {orderData?.shipping?.address1}
                </Typography>
                <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                  {orderData?.shipping?.address2}
                </Typography>
                <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                  {orderData?.shipping?.postal_code}
                </Typography>
                <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                  {orderData?.shipping?.city}
                </Typography>
                <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                  {`${orderData?.shipping?.state}, ${orderData?.shipping?.country}`}
                </Typography>
                <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                  {orderData?.shipping?.phone}
                </Typography>
              </Grid>
              <Grid item xs={4} sx={{ justifyContent: 'center' }}>
                <Typography variant={'h1'} sx={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '20px' }}>
                  Billing Address
                </Typography>
                <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                  {`${orderData?.customer?.first_name} ${orderData?.customer?.last_name}`}
                </Typography>
                <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                  {orderData?.customer?.company}
                </Typography>
                <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                  {orderData?.customer?.address1}
                </Typography>
                <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                  {orderData?.customer?.address2}
                </Typography>
                <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                  {orderData?.customer?.postal_code}
                </Typography>
                <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                  {orderData?.customer?.city}
                </Typography>
                <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                  {`${orderData?.customer?.state}, ${orderData?.customer?.country}`}
                </Typography>
                <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                  {orderData?.customer?.phone}
                </Typography>
              </Grid>
            </Grid>
          </CardComponent>

          {/* Per-Item Sections */}
          {orderData?.order_items?.map((item, itemIdx) => {
            const itemImgUrl = handleReplace(item?.metadata);
            const thumbnails = [
              { label: 'Image', url: item?.metadata?.image },
              { label: 'Image 2', url: item?.metadata?.image_2 },
              { label: 'Print URL 1', url: item?.metadata?.print_url_1 },
              { label: 'Print URL 2', url: item?.metadata?.print_url_2 },
            ].filter((t) => t.url);

            return (
              <CardComponent
                key={item?.id || itemIdx}
                title={`Item ${itemIdx + 1} of ${orderData.order_items.length}`}
                sx={{ mt: 2 }}>
                <Grid container spacing={2}>
                  {/* Item Image */}
                  <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }}>
                    <img
                      src={itemImgUrl}
                      alt={item?.name || `Item ${itemIdx + 1}`}
                      height={200}
                      style={{ maxWidth: '350px' }}
                    />
                  </Grid>

                  {/* Item Details */}
                  <Grid item xs={4} sx={{ justifyContent: 'center' }}>
                    <Typography variant={'h1'} sx={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '20px' }}>
                      {item?.name}
                    </Typography>
                    {item?.price && (
                      <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                        {`Price : ${item.price}`}
                      </Typography>
                    )}

                    {item?.quantity && (
                      <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                        {`Quantity : ${item.quantity}`}
                      </Typography>
                    )}

                    {item?.code && (
                      <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                        {`Product Code : ${item.code}`}
                      </Typography>
                    )}

                    {(item?.variation_list?.Size || item?.variation_list?.size) && (
                      <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                        {`Size : ${item.variation_list.Size || item.variation_list.size}`}
                      </Typography>
                    )}

                    {(item?.variation_list?.Color || item?.variation_list?.color) && (
                      <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                        {`Color : ${item.variation_list.Color || item.variation_list.color}`}
                      </Typography>
                    )}

                    {/* {item?.metadata?.print_sku && (
                      <Typography variant={'h3'} sx={{ fontSize: '14px' }}>
                        {`Model : ${item.metadata.print_sku}`}
                      </Typography>
                    )} */}
                  </Grid>

                  {/* Item Thumbnails */}
                  <Grid item xs={4}>
                    {thumbnails.length > 0 && (
                      <Grid container spacing={2}>
                        {thumbnails.map((t, tIdx) => {
                          const thumb = getThumbnail(t.url);
                          return (
                            <Grid item xs={6} key={tIdx} sx={{ textAlign: 'center' }}>
                              <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5, fontSize: '13px' }}>
                                {t.label}
                              </Typography>
                              <a href={thumb || t.url} target="_blank" rel="noopener noreferrer">
                                <img
                                  src={thumb || `${ASSET_IMAGES}/no-img.png`}
                                  alt={t.label}
                                  style={{
                                    width: 100,
                                    height: 100,
                                    objectFit: 'contain',
                                    border: '1px solid #ddd',
                                    borderRadius: 6,
                                    padding: 4,
                                  }}
                                />
                              </a>
                            </Grid>
                          );
                        })}
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </CardComponent>
            );
          })}
        </>
      )}
    </>
  );
};

export default OrderInfo;
